import { Link } from "react-router-dom";
import { Seo } from "../lib/seo";
import { MaskedLines } from "../components/motion";

export const NotFound = () => (
  <>
    <Seo title="Page Not Found" description="The page you are looking for does not exist." path="/404" />
    <section className="relative flex min-h-screen items-center overflow-hidden bg-navy">
      <div className="absolute inset-0 blueprint-grid" aria-hidden="true" />
      <div className="absolute -right-32 top-1/4 h-[420px] w-[420px] rounded-full bg-gold/10 blur-[130px]" aria-hidden="true" />
      <div className="container-x relative py-32 text-center">
        <p className="eyebrow-on-dark">Error 404</p>
        <MaskedLines
          lines={["This page does", "not exist."]}
          className="mx-auto mt-6 text-5xl font-medium leading-[1.08] tracking-tight text-white sm:text-7xl"
          delay={0.15}
        />
        <p className="mx-auto mt-7 max-w-md text-base leading-relaxed text-white/55">
          The link may be old, or the page may have moved. The practice's main
          pages are a click away.
        </p>
        <div className="mt-10 flex flex-col justify-center gap-4 sm:flex-row">
          <Link to="/" data-testid="not-found-home-button" className="btn-gold">
            Back to Home
          </Link>
          <Link to="/contact" className="btn-outline-light">
            Submit an Enquiry
          </Link>
        </div>
      </div>
    </section>
  </>
);

export default NotFound;
